import { render, staticRenderFns } from "./VoiceAnimation.vue?vue&type=template&id=6413b2ff"
var script = {}
import style0 from "./VoiceAnimation.vue?vue&type=style&index=0&id=6413b2ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports